export default {
  icon: {
    fontSise: '1.5rem',
  },
  checkbox: {
    width: '20px',
    height: '20px',
    color: (theme) => `${theme.palette.grays.gray500}`,
    padding: 0,
    '&.Mui-checked': {
      color: (theme) => `${theme.palette.blues.primaryBlue500}`,
    },
    '&.Mui-disabled': {
      opacity: '.5',
    },
    '&:hover': {
      background: 'none',
    },
  },
};
